import React from "react";
import {
  EnrichedSwarovskiProductFrontendProductAggregatedReviews,
  SwarovskiOptikLocaleFrontend,
} from "@swo/storefront";
import { PDPReviewsHistorgramBar } from "./PDPReviewsHistorgramBar";

export const PDPReviewsHistorgram: React.FC<{
  data: NonNullable<EnrichedSwarovskiProductFrontendProductAggregatedReviews>;
  locale: SwarovskiOptikLocaleFrontend;
  onClick: (starValue: number) => void;
}> = ({ data, locale, onClick }) => {
  return (
    <ul className="u-flex u-flex-col u-gap-2 u-mt-4">
      {new Array(5)
        .fill(null)
        .map((_, idx) => 5 - idx)
        .map(starValue => (
          <PDPReviewsHistorgramBar
            key={starValue}
            starValue={starValue}
            data={data}
            onClick={() => onClick(starValue)}
          />
        ))}
    </ul>
  );
};
